/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from 'owa-viewstate-store';
import { createStore } from 'owa-satcheljs';

import type { FlexibleWorkingHoursView } from 'owa-graph-schema';

// TODO: workplanFWH & currentDayFWH can be consolidated
// We are keeping them separate to minimize PR impact and maintain the existing logic
// https://outlookweb.visualstudio.com/MicrosoftPlaces/_boards/board/t/FC%20-%20Work%20Plans/Stories/?workitem=271738
const dest = createAccessors(
    'hybridspace-home-store',
    createStore('hybridspace-home-store', {
        workplanFWH: undefined as FlexibleWorkingHoursView[] | undefined, // FWH for the workplan week
        currentDayFWH: undefined as FlexibleWorkingHoursView[] | undefined, // FWH for the current day
    })
);
const getWorkplanFWH: () => FlexibleWorkingHoursView[] | undefined = dest.getWorkplanFWH;
const setWorkplanFWH: (newValue: FlexibleWorkingHoursView[] | undefined) => void =
    dest.setWorkplanFWH;
const getCurrentDayFWH: () => FlexibleWorkingHoursView[] | undefined = dest.getCurrentDayFWH;
const setCurrentDayFWH: (newValue: FlexibleWorkingHoursView[] | undefined) => void =
    dest.setCurrentDayFWH;

export { getWorkplanFWH, setWorkplanFWH, getCurrentDayFWH, setCurrentDayFWH };
